import { FC } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface FooterInfoItemProps {
  text: string;
}

export const FooterInfoItem: FC<FooterInfoItemProps> = observer(({ text }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: 4,
        border: '1px solid #D6D6D6',
        py: 1,
        px: 2,
      }}
    >
      {text}
    </Typography>
  );
});
